export var SET_CART_DATA = "SET_CART_DATA";
export var UPDATE_CART_DATA = "UPDATE_CART_DATA";
export var SET_QUESTIONS_DATA = "SET_QUESTIONS_DATA";
export var UPDATE_QUESTIONS_DATA = "UPDATE_QUESTIONS_DATA";
export var UPDATE_CART_STATUS = "UPDATE_CART_STATUS";
export var UPDATE_QUESTIONS_STATUS = "UPDATE_QUESTIONS_STATUS";
